import { type ReactNode, createContext, useContext, useMemo } from "react";
import { AgentChatComposerDraftProvider } from "./agent-chat-composer-draft-context";
import { useAgentChat } from "./use-agent-chat";

type AgentChatContextValue = ReturnType<typeof useAgentChat>;

const AgentChatContext = createContext<AgentChatContextValue | null>(null);

export function AgentChatProvider({ children }: { children: ReactNode }) {
	const chat = useAgentChat();
	const value = useMemo(() => chat, [chat]);

	return (
		<AgentChatContext.Provider value={value}>
			<AgentChatComposerDraftProvider>
				{children}
			</AgentChatComposerDraftProvider>
		</AgentChatContext.Provider>
	);
}

export function useAgentChatContext(): AgentChatContextValue {
	const context = useContext(AgentChatContext);
	if (!context) {
		throw new Error(
			"useAgentChatContext must be used within AgentChatProvider",
		);
	}
	return context;
}
